/**
 * ApodoRepository — SÓLO LECTURA (web). Los apodos llegan por el PULL (bulkPutSilent, que
 * no emite cambios) y nunca se escriben desde la web: add/update/delete tiran.
 */
import { Apodo, IApodoRepository } from '../interfaces/IApodoRepository';
import { BaseRepository } from './BaseRepository';
import { IDatabaseAdapter } from '../adapters/IDatabaseAdapter';
import { IProfileRepository } from '../interfaces/IProfileRepository';

const SOLO_LECTURA = 'Los apodos se crean desde el asistente: la web sólo los lee.';

export class ApodoRepository extends BaseRepository<Apodo, string> implements IApodoRepository {
  constructor(db: IDatabaseAdapter, profileRepo?: IProfileRepository) {
    super(db, 'apodos', 'apodos');
    this.supportsSoftDelete = true;
    if (profileRepo) this.setProfileRepository(profileRepo);
  }

  async add(): Promise<string> { throw new Error(SOLO_LECTURA); }
  async update(): Promise<void> { throw new Error(SOLO_LECTURA); }
  async delete(): Promise<void> { throw new Error(SOLO_LECTURA); }

  async getDePersonas(empresaId: string): Promise<Apodo[]> {
    const rows = await this.db.queryMultiple<Apodo>('apodos', [
      { field: 'is_deleted', operator: 'equals', value: false },
      { field: 'empresa_id', operator: 'equals', value: empresaId },
    ]);
    return rows.filter((a) => a.tipo_entidad === 'usuario' || a.tipo_entidad === 'persona');
  }
}
